import React, { memo } from 'react';
import { ModernVideoModelNode } from './ModernVideoModelNode';
import { MINIMAX_H3_CONFIG } from './videoModelConfigs';

export const MinimaxH3VideoNode = memo(props => (
  <ModernVideoModelNode {...props} config={MINIMAX_H3_CONFIG} />
));
